<div class="menu">

  <button
      class="menu__label"
      app-button
      buttonType="text"
      buttonTheme="dark"
      [matMenuTriggerFor]="localeSelections">

      <fa-icon icon="globe" size="lg"></fa-icon>
      <span class="text-uppercase text-11 hide-sm">
        {{(userLocale$ | async)?.title}}
      </span>

      <!-- <app-button-icon
        class="text-20"
        icon="globe"
        iconType="regular"
        iconPlacement="left"
        [label]="(userLocale$ | async)?.title"></app-button-icon> -->
        
  </button>
    
  <mat-menu #localeSelections="matMenu">
    <span class="menu__beta">Beta version</span>
    <button
      class="menu__item"
      mat-menu-item
      *ngFor="let locale of locales"
      (click)="handleLocaleSelected(locale)">
        {{ locale.title }}
    </button>
  </mat-menu>

</div>